import React, { useRef, useState } from "react";
import btnImg from "../images/WITH-ALPHA-CHANNEL_GIhan_BTV_Creation_2nd-option__the-better-Y-BUTTON_Fiverr-Test_.gif";
import CameraComponent from "../camera/Camera";
import { useNavigate } from 'react-router-dom';

import './form.css';

/** Convert a data URL (base64) or Blob to a Blob so FormData sends it as a file part. */
function toBlob(image) {
  if (!image) return null;
  if (image instanceof Blob) return image;
  if (typeof image !== "string" || !image.startsWith("data:")) return null;
  const [header, base64] = image.split(",");
  if (!base64) return null;
  const mime = (header.match(/data:([^;]+)/) || [])[1] || "image/jpeg";
  const bin = atob(base64);
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
  return new Blob([bytes], { type: mime });
}

const FormOne = ({ productId, onNextStep, amount }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [capturedImageBlob, setCapturedImageBlob] = useState(null);
  const [error, setError] = useState(null);
  const [formClass, setFormClass] = useState('hide');

  const cameraRef = useRef(null);
  const capturedImageRef = useRef(null);

  const totalSections = 3;
  const [formData, setFormData] = useState({
    priceId: productId,
    image: null,
    firstName: "",
    lastName: "",
    email: "",
    amount
  });

  const navigate = useNavigate();

  React.useEffect(() => {
    onNextStep(currentStep);
    if (currentStep <= 1) {
      setTimeout(() => {
        setFormClass('show');
      }, 3300);
    }
  }, [currentStep]);

  React.useEffect(() => {
    if (capturedImageBlob && currentStep === 1) {
      handleNext();
    }
  }, [capturedImageBlob, currentStep]);

  const handleCapture = (blob) => {
    capturedImageRef.current = blob;
    setCapturedImageBlob(blob);

    setFormData(prev => ({ ...prev, image: blob }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const isStep2Valid = () => {
    const first = (formData.firstName || '').trim();
    const last = (formData.lastName || '').trim();
    return first.length >= 3 && first.length <= 13 && last.length >= 3 && last.length <= 13;
  };

  const isStep3Valid = () => {
    const email = (formData.email || '').trim();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return email.length > 0 && emailRegex.test(email);
  };

  const handleNext = () => {
    if (currentStep === 2 && !isStep2Valid()) return;
    setFormClass('hide');
    setTimeout(() => {
      setFormClass('show');
    }, 3600);
    setTimeout(() => {
      setCurrentStep((prevSection) =>
        prevSection < totalSections ? prevSection + 1 : prevSection
      );
    }, 200);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isStep3Valid()) return;
    console.log("Submitting formData:", formData);
    console.log("Captured Image Blob:", capturedImageBlob);

    try {
      // Append other user registration data to the FormData object
      const formDataObject = new FormData();
      // Use ref first so we never lose the blob after formData updates (stale closure)
      const imageInput = capturedImageRef.current ?? capturedImageBlob ?? formData.image;
      const imageBlob = toBlob(imageInput);
      Object.entries(formData).forEach(([key, value]) => {
        if (key === "image") {
          if (imageBlob) {
            formDataObject.append(key, imageBlob, "captured-user-image.jpeg");
          }
        } else {
          formDataObject.append(key, value ?? "");
        }
      });

      // Log FormData entries for verification
      for (let pair of formDataObject.entries()) {
        console.log(pair[0] + ', ' + pair[1]);
      }

      const response = await fetch("https://api.yaavaay.com/v2/users", {
        method: "POST",
        body: formDataObject,
      });
      if (response.ok) {
        // Handle successful API response
        const userData = await response.json();
        // Redirect to stripe checkout.
        // window.location.href = userData.checkoutUrl;
        navigate("/payment", { state: { userData } })
        // navigate("/payment", { state: { userData } })

      } else {
        let msg = "Something went wrong.";
        try {
          const body = await response.json();
          msg = body.message || body.error || msg;
        } catch (_) {}
        throw new Error(msg);
      }
    } catch (error) {
      setError(error.message);
    }
  };

  const renderSection = () => {
    switch (currentStep) {
      case 1:
        return (
          <>
            <div class="spacer"></div>
            <div className="input-main">
              <div className="input-container" style={{ transform: 'unset' }}>
                <CameraComponent ref={cameraRef} onCapture={handleCapture} />
              </div>
            </div>
            <button
              onClick={(e) => { cameraRef.current?.cap(e); }}
              type="button"
              className="button-names form-button-next"
              style={{ marginTop: 20 }}
            >
              <img src={btnImg} alt="y-logo" style={{ objectFit: "contain" }} />
            </button>
          </>
        );
      case 2:
        return (
          <>
            <div class="spacer"></div>
            <div className="input-main">
              <div className="input-container">
                <div className="any">
                  <input
                    type="text"
                    name="firstName"
                    placeholder="First Name"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                    minLength={3}
                    maxLength={13}
                  />
                  <input
                    type="text"
                    name="lastName"
                    placeholder="Last Name"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                    minLength={3}
                    maxLength={13}
                  />
                </div>
              </div>
            </div>
            <button
              onClick={handleNext}
              type="button"
              className="button-names form-button-next"
              style={{ marginTop: 20 }}
              disabled={!isStep2Valid()}
            >
              <img src={btnImg} alt="y-logo" style={{ objectFit: "contain" }} />
            </button>
          </>
        );
      case 3:
        return (
          <>
            <div class="spacer"></div>
            <div className="input-main">
              <div className="input-container">
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
          </>
        );
      default:
        return null;
    }
  };

  return (<div className="diff-container">
    <form className={formClass} onSubmit={handleSubmit}>
      {renderSection()}
      {currentStep === totalSections && (
        <button type="submit" className="button-names form-button-next" disabled={!isStep3Valid()}>
          <img src={btnImg} alt="y-logo" style={{ objectFit: "contain" }} />
        </button>
      )}
    </form>
    {error && <p>{error}</p>}
  </div>

  );
};

export default FormOne;
